<template>
  <!-- 过渡动画 -->
  <transition name="fade">
    <div class="img-view" id="img-view" @click="bigImg">
      <!-- 遮罩层 -->
      <div class="img-layer"></div>
      <div class="img">
        <img :src="imgSrc" id="bigImgBox" />
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ["imgSrc"], //接受图片地址
  mounted() {
    // const img_view = document.getElementById("img-view").clientHeight;
    //   const img = document.getElementById("bigImgBox");
    //   img.style.marginTop = img_view-150+'px';
    //   img.style.marginBottom = img_view-150+'px';
  },
  methods: {
    bigImg() {
      // 发送事件
      this.$emit("clickit");
    },
  },
};
</script>
<style scoped lang='less'>
/*动画*/
　　.fade-enter-active,
　　.fade-leave-active {
  transition: all 0.2s linear;
  transform: translate3D(0, 0, 0);
}
　　.fade-enter,
　　.fade-leave-active {
  transform: translate3D(100%, 0, 0);
}

/* bigimg */
　　.img-view {
  // position: inherit;
  width: 100%;
  height: 100%;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
}
.img {
  height: 100%;
}

/*遮罩层样式*/
　　.img-view .img-layer {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: hidden;
}
/*不限制图片大小，实现居中*/
　　.img-view .img img {
  max-width: 100%;
  width: 96%;
  display: block;
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  height: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>
